import { PostBookingInquiry, bookingInquiryApis } from '@apis/bookingInquiryApis';
import { useMutation } from '@hooks/useMutation';
import { FormError } from '@utils/errors';

export const useBookingInquiryCreate = () => {
  return useMutation(async (body: PostBookingInquiry) => {
    const response = await bookingInquiryApis.post('/booking-inquiry/', { body });
    if (response[400]) {
      throw new FormError('BookingInquiryCreateError', response[400]);
    }
    return response[200]!;
  });
};
